import { filter } from 'lodash';
import axios from 'axios';
import { useState, useEffect } from 'react';
import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Container,
  TableContainer,
  TablePagination,
  IconButton,
  styled,
  Backdrop,
  CircularProgress
} from '@material-ui/core';

import DeleteForever from '@material-ui/icons/DeleteForever';
import { baseUrl } from '../../utils/constants';
import SearchNotFound from '../SearchNotFound';
import { ClientListHead } from '../_dashboard/clients';
import Controls from '../controls/Controls';

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover
  },
  '&:last-child td, &:last-child th': {
    border: 0
  }
}));

const TABLE_HEAD = [
  { id: 'refids', label: 'Run #', alignRight: true },
  { id: 'clientref', label: 'Client RefId', alignRight: true },
  { id: 'empno', label: 'Employee #', alignRight: false },
  { id: 'claimtype', label: 'Claim Type', alignRight: false },
  { id: 'amount', label: 'Amount', alignRight: true },
  { id: 'errTyp', label: 'Error Type', alignRight: false },
  { id: 'nimo', label: 'Claimant', alignRight: false },
  { id: 'asd', label: '' }
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_doc) => _doc.documentType.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function ClaimsImportItems(id) {
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [orderBy, setOrderBy] = useState('documentType');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
    heading: '',
    color: '#000000'
  });
  // const navigate = useNavigate();

  useEffect(() => {
    GetClaimsImportItems();
    setSelected([]);
    setFilterName('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const GetClaimsImportItems = async () => {
    setLoading(true);
    fetch(`${baseUrl}/api/claims/GetClaimsImportItems?refId=${id.id}`)
      .then((result) => result.json())
      .then(
        (result) => {
          console.log('GetClaimsImportItems returned  ', result);
          setDataList(result.result);
          setLoading(false);
        },
        (error) => {
          setLoading(false);
          notifyPopup(`Error in Retrieving GetClaimsImportItems!: ${error}`, 'error');
        }
      );
  };

  const handleLineDelete = async (e) => {
    console.log('e here', e.row.refId);
    if (e === '') {
      return;
    }
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false
    });
    setLoading(true);
    await axios.post(`${baseUrl}/api/claims/deleteClaimImportLine?refId=${e.row.refId}`).then(
      (result) => {
        setLoading(false);
        if (result.replyStatus === 1) {
          notifyPopup(`Error in Deleting Claim!: ${result.replyMessage}`, 'error');
        } else {
          GetClaimsImportItems();
          notifyPopup(`Import Line Deleted Successfully!`, 'success');
        }
      },
      (error) => {
        notifyPopup(`Error in Deleting Import Line!: ${error}`, 'error');
      }
    );
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataList.length) : 0;

  const filteredUsers = applySortFilter(dataList, getComparator(order, orderBy), filterName);

  const isUserNotFound = filteredUsers.length === 0;

  const handleLoadingClose = () => {
    setLoading(false);
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  return (
    <Container>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handleLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Card>
        <TableContainer sx={{ minWidth: 800 }}>
          <Table size="small" aria-label="a dense table">
            <ClientListHead
              order={order}
              orderBy={orderBy}
              headLabel={TABLE_HEAD}
              rowCount={dataList.length}
              numSelected={selected.length}
              onRequestSort={handleRequestSort}
              // onSelectAllClick={handleSelectAllClick}
            />
            <TableBody>
              {filteredUsers
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => {
                  /* eslint-disable camelcase */
                  const {
                    refId,
                    clientRefId,
                    employeeNumber,
                    claimType,
                    errorType,
                    amountClaimed,
                    claimantSurname,
                    claimantForename
                  } = row;
                  const isItemSelected = selected.indexOf(refId) !== -1;

                  return (
                    <StyledTableRow
                      hover
                      key={refId}
                      tabIndex={-1}
                      role="checkbox"
                      selected={isItemSelected}
                      aria-checked={isItemSelected}
                    >
                      <TableCell padding="checkbox" />
                      <TableCell align="right">{refId}</TableCell>
                      <TableCell align="right">{clientRefId}</TableCell>
                      <TableCell align="left">{employeeNumber}</TableCell>
                      <TableCell align="left">{claimType}</TableCell>
                      <TableCell align="right">{amountClaimed.toFixed(2)}</TableCell>
                      <TableCell align="left">{errorType}</TableCell>
                      <TableCell align="left">
                        {claimantSurname} {claimantForename}
                      </TableCell>
                      <TableCell align="right">
                        {/* <IconButton onClick={() => handleLineDelete({ row })}> */}
                        <IconButton
                          onClick={() =>
                            setConfirmDialog({
                              isOpen: true,
                              title: 'Are you sure you want to Delete Claim Line',
                              subTitle: "You can't undo this action",
                              heading: 'Delete Line Claim',
                              color: '#00000',
                              onConfirm: () => {
                                handleLineDelete({ row });
                              }
                            })
                          }
                        >
                          <DeleteForever sx={{ color: '#f44336' }} />
                        </IconButton>
                      </TableCell>
                    </StyledTableRow>
                  );
                })}
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
            {isUserNotFound && (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                    <SearchNotFound searchQuery={filterName} />
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>
        <Controls.Notification notify={notify} setNotify={setNotify} />
        <Controls.ConfirmDialog confirmDialog={confirmDialog} setConfirmDialog={setConfirmDialog} />

        <TablePagination
          sx={{
            backgroundColor: 'black',
            color: 'white',
            size: 'small'
          }}
          rowsPerPageOptions={[8, 16, 24]}
          component="div"
          count={dataList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
    </Container>
  );
}
